import { render } from "./item-special-offer.vue?vue&type=template&id=65318746&scoped=true"
import script from "./item-special-offer.vue?vue&type=script&lang=js"
export * from "./item-special-offer.vue?vue&type=script&lang=js"

import "./item-special-offer.vue?vue&type=style&index=0&id=65318746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65318746"]])

export default __exports__